/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CumulativeSessionCost
 */
export interface CumulativeSessionCost {
    /**
     * for debugging. The raw db row timestamp.
     * @type {Date}
     * @memberof CumulativeSessionCost
     */
    rowValueUtc?: Date;
    /**
     * The truncated time in UTC for the beginning of the interval (eg 'January' 2022 would be `2021-12-31T16:00:00`
     * @type {Date}
     * @memberof CumulativeSessionCost
     */
    timestamp?: Date;
    /**
     * Date label, to avoid timezone conversions in frontend. eg:
     * Hour: yyyy-MM-ddTHH:00:00
     * Day: yyyy-MM-dd
     * Week: 2022W01 (week-of-year, new weeks start on Sunday)
     * Month: 2022M01
     * @type {string}
     * @memberof CumulativeSessionCost
     */
    label?: string;
    /**
     * The cost for sessions that started in this interval
     * @type {number}
     * @memberof CumulativeSessionCost
     */
    cost?: number;
}

/**
 * Check if a given object implements the CumulativeSessionCost interface.
 */
export function instanceOfCumulativeSessionCost(
    value: object,
): value is CumulativeSessionCost {
    return true;
}

export function CumulativeSessionCostFromJSON(
    json: any,
): CumulativeSessionCost {
    return CumulativeSessionCostFromJSONTyped(json, false);
}

export function CumulativeSessionCostFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CumulativeSessionCost {
    if (json == null) {
        return json;
    }
    return {
        rowValueUtc:
            json["rowValueUtc"] == null
                ? undefined
                : new Date(json["rowValueUtc"]),
        timestamp:
            json["timestamp"] == null ? undefined : new Date(json["timestamp"]),
        label: json["label"] == null ? undefined : json["label"],
        cost: json["cost"] == null ? undefined : json["cost"],
    };
}

export function CumulativeSessionCostToJSON(
    value?: CumulativeSessionCost | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        rowValueUtc:
            value["rowValueUtc"] == null
                ? undefined
                : value["rowValueUtc"].toISOString(),
        timestamp:
            value["timestamp"] == null
                ? undefined
                : value["timestamp"].toISOString(),
        label: value["label"],
        cost: value["cost"],
    };
}
